import React from "react"
import { formatDateTime } from "../transactions/format"
import { StatusPill } from "./StatusPill"
import { DevelopmentStoreControl } from "./DevelopmentStoreControl"

// Merchant detail header: shop name/domain, app, status pill, and the lifecycle
// dates. The plain "—" fallback (copy.none) keeps empty fields honest.
export function MerchantHeader({ merchant, devStorePath, canFlagDevStore, onMerchantUpdated, copy }) {
  const dash = copy.none
  const stat = (label, value) => (
    <div>
      <dt className="text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">{label}</dt>
      <dd className="mt-1 text-sm text-gray-900 dark:text-gray-100">{value || dash}</dd>
    </div>
  )

  return (
    <div className="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-6">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">{merchant.name}</h1>
          <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">{merchant.shop}</p>
          <p className="mt-1 text-sm text-gray-600 dark:text-gray-400">{merchant.app || dash}</p>
        </div>
        <div className="flex flex-col items-end gap-2">
          <StatusPill status={merchant.status} copy={copy} />
          {devStorePath && (
            <DevelopmentStoreControl
              merchant={merchant}
              devStorePath={devStorePath}
              canFlag={canFlagDevStore}
              copy={copy}
              onUpdated={onMerchantUpdated}
            />
          )}
        </div>
      </div>
      {merchant.is_development_store && (
        <p className="mt-3 rounded-lg bg-amber-50 dark:bg-amber-950/40 px-3 py-2 text-xs text-amber-700 dark:text-amber-300">
          {copy.devStore.explainer}
        </p>
      )}
      <dl className="mt-6 grid grid-cols-2 gap-4 sm:grid-cols-4">
        {stat(copy.currentPlan, merchant.current_plan)}
        {stat(copy.installedAt, formatDateTime(merchant.first_installed_at))}
        {stat(copy.uninstalledAt, merchant.uninstalled_at ? formatDateTime(merchant.uninstalled_at) : null)}
        {stat(copy.lastEventAt, formatDateTime(merchant.last_event_at))}
        {merchant.uninstall_reason ? stat(copy.uninstallReason, merchant.uninstall_reason) : null}
      </dl>
    </div>
  )
}
